import moment from 'moment';
import { Box, Heading, useColorModeValue, Stack, StackDivider, Text } from '@chakra-ui/react';
import { TooltipProps } from 'recharts';
import { IndexData } from 'models/types';

interface IndexTooltipProps extends TooltipProps<any, any> {
	indexPriceData: IndexData[];
}

const IndexTooltip = ({ active, payload, indexPriceData }: IndexTooltipProps) => {
	const bgColor = useColorModeValue('white', 'navy.800');
	const textColor = useColorModeValue('secondaryGray.900', 'white');
	const textColorSecondary = useColorModeValue('secondaryGray.600', 'white');
	const borderColor = useColorModeValue('gray.200', 'whiteAlpha.200');

	if (!active || !payload || !payload.length) {
		return null;
	}

	const data = payload[0].payload;
	const currentDate = moment(data.date);
	const indexDataIndex = indexPriceData.findIndex(v => moment(v.date).isSame(currentDate));
	let previousValue = 0;
	let delta = 0;

	if (indexDataIndex > 0) {
		previousValue = indexPriceData[indexDataIndex - 1].weightedIndex;
		delta = data.weightedIndex - previousValue;
	}

	return (
		<Box
			bg={bgColor}
			p={4}
			borderRadius="lg"
			boxShadow="lg"
			border="1px solid"
			borderColor={borderColor}
		>
			<Stack spacing={3}>
				<Box>
					<Text color={textColorSecondary} fontSize="sm">
						Date
					</Text>
					<Heading size="sm" color={textColor}>
						{currentDate.format('YYYY-MM-DD')}
					</Heading>
				</Box>
				<StackDivider />
				<Box>
					<Text color={textColorSecondary} fontSize="sm">
						Index
					</Text>
					<Heading size="sm" color={textColor}>
						{data.weightedIndex.toFixed(2)}
					</Heading>
				</Box>
				{!!indexDataIndex && !!delta && (
					<Box>
						<Text color={textColorSecondary} fontSize="sm">
							Change
						</Text>
						<Heading size="sm" color={delta > 0 ? 'green.500' : 'red.500'}>
							{delta > 0 ? '+' : ''}{delta.toFixed(2)}
						</Heading>
					</Box>
				)}
			</Stack>
		</Box>
	);
};

export default IndexTooltip;